import React from "react";
import "./EARadio.scss";

interface IProps {
  name: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

const EARadio: React.FC<IProps> = ({ name, value, checked, onChange, label, disabled = false }) => {
  return (
    <div className="custom-radio__container">
      <label className={`custom-radio__wrapper ${disabled ? "custom-radio__wrapper--disabled" : ""}`}>
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={() => onChange(value)}
          className="custom-radio__input"
        />
        {label && <p className="custom-radio__label no-line-height">{label}</p>}
      </label>
    </div>
  );
};

export default EARadio;
